import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../core/Link/index';

export const StyledNavigation = styled.nav`
  display: flex;
  flex-wrap: no-wrap;
  text-align: center;
  align-items: center;
  justify-content: space-evenly;
  height: 53px;

  &.primary {
    a {
      font-size: 0.88rem;
      padding: 18.5px;
      max-height: 53px;
      span {
        font-family: 'Rubik', sans-serif;
        color: ${themeGet('colors.nav-links')};
        font-weight: 500;
      }
      &.active {
        background-color: ${themeGet('colors.spinSecondaryOne')};
        border-radius: 0;
      }
    }

    a:hover {
      background-color: ${themeGet('colors.spinSecondaryOne')};
      border-radius: 0;
    }
  }

  &.secondary {
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
    position: relative;
    top: -6px;

    @media only screen and (max-width: ${themeGet('breakpoints.lg')}) {
      visibility: hidden;
    }

    a {
      font-size: 0.75rem;
      border-top: 5px solid transparent;
      color: ${themeGet('spinTextDark')};

      span {
        font-family: 'Rubik', sans-serif;
        font-weight: 500;
        color: ${themeGet('spinTextDark')};
      }
    }

    a:hover {
      background-color: transparent;
      border-top: 5px solid ${themeGet('colors.spinSecondaryOne')};
      span {
        font-weight: 600;
      }
    }
  }

  @media only screen and (max-width: ${themeGet('breakpoints.lg')}) {
    position: absolute;
    width: 100vw;
    transition: all 0.4s cubic-bezier(0.45, 0, 0.55, 1);
    top: ${({ open }) => (open ? '60px' : '-100vh')};
    display: block;
    background-color: ${themeGet('colors.whiteSnow')};
    text-align: center;
    height: auto;
    z-index: 99;
    padding-bottom: 20px;
    padding-top: 2rem;
    left: -2.5rem;
    &.primary a.internalStyledLink {
      font-size: 1.5rem;
      width: 100%;
      display: block;
      position: relative;
      padding-top: 13px;
    }
  }
  @media only screen and (max-width: 1152px) {
    a {
      display: flex;
      align-content: center;
      align-items: center;
    }
  }
`;

export const MenuLink = styled(Link)`
  padding: 15px;
  &.active {
    color: darkred;
  }
`;

export const MobileMenuBackground = styled.div`
  position: fixed;
  width: 100vw;
  height: ${(props) => (props.open ? 'calc(100vh - 60px)' : 0)};
  background: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 70px;
  transition: opacity 0.4s ease-out;
  /* display: ${(props) => (props.open ? 'visible' : 'none')}; */
  opacity: ${(props) => (props.open ? 1 : 0)};

  @media only screen and (min-width: Calc(${themeGet(
      'breakpoints.lg',
    )} + 1px)) {
    display: none;
  }
`;
